import api from './api';

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface User {
  username: string;
  role: string;
  name: string;
}

export interface LoginResponse {
  success: boolean;
  token: string;
  user: User;
  message?: string;
}

export const authService = {
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const payload = {
      username: credentials.username,
      password: credentials.password
    };
    const response = await api.post<LoginResponse>('/api/auth/login', payload);
    return response.data;
  },

  async verify(): Promise<{ success: boolean; user: User }> {
    const response = await api.get('/api/auth/verify');
    return response.data;
  },

  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  },

  getToken(): string | null {
    return localStorage.getItem('authToken');
  },

  getUser(): User | null {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  setAuth(token: string, user: User) {
    localStorage.setItem('authToken', token);
    localStorage.setItem('user', JSON.stringify(user));
  },
};
